var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: { position: _vm.modalPosition, minimized: "" },
      on: {
        hide: function($event) {
          _vm.$emit("change-modal-state", true)
        }
      },
      model: {
        value: _vm.dialogTicketsTypes,
        callback: function($$v) {
          _vm.dialogTicketsTypes = $$v
        },
        expression: "dialogTicketsTypes"
      }
    },
    [
      _c(
        "div",
        { staticClass: "q-pa-md" },
        [
          _c("div", [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("label.downloadTicket")) + "\n    "
            )
          ]),
          !_vm.googleWalletLoading
            ? _c(
                "q-list",
                { attrs: { "no-border": "" } },
                _vm._l(_vm.linkList, function(ticket, index) {
                  return _c(
                    "q-item",
                    {
                      key: index,
                      attrs: {
                        color: _vm.SET_COLOR_BUTTON.primary,
                        "text-color": _vm.SET_COLOR_BUTTON.text.primary,
                        label: _vm.$t("label.downloadTicket")
                      }
                    },
                    [
                      _c(
                        "q-item-main",
                        { staticClass: "text-center" },
                        [
                          _c(_vm.getDownloadButton(ticket.type), {
                            tag: "component",
                            attrs: { ticket: ticket },
                            on: { "start-download": _vm.download }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              )
            : _c(
                "div",
                { staticClass: "loading" },
                [
                  _c("q-spinner", {
                    attrs: { color: "deep-purple", size: "3em", thickness: 10 }
                  })
                ],
                1
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }